export const contentTextWidth =
  'max-w-[522px] md:max-w-[776px] lg:max-w-[936px]';
